import { Navigate } from 'react-router-dom'

export const PrivateRoute = ({ children }) => {
    let userid = localStorage.getItem("uid") ? true : false;
    // console.log(userid)
    return (
        <>{userid ? children : <Navigate to="/login" />}</>
    )
}